import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, Pencil, Trash2 } from "lucide-react";
import api from "@/lib/api";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      if (typeFilter) params.type = typeFilter;
      const { data } = await api.get("/products", { params });
      setProducts(data);
    } catch { /* */ }
    setLoading(false);
  };

  useEffect(() => { fetchProducts(); }, [typeFilter]);
  const handleSearch = (e) => { e.preventDefault(); fetchProducts(); };
  const handleDelete = async (id) => {
    if (!window.confirm("Tem certeza que deseja remover este produto?")) return;
    await api.delete(`/products/${id}`);
    fetchProducts();
  };

  return (
    <div data-testid="product-list-page">
      <div className="flex items-center justify-between mb-8">
        <h1 className="crm-heading">Produtos</h1>
        <Link to="/crm/products/new" data-testid="add-product-btn" className="crm-btn-primary"><Plus className="w-4 h-4" /> Novo Produto</Link>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <form onSubmit={handleSearch} className="flex-1 relative">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: "var(--crm-text-dim)" }} />
          <input value={search} onChange={(e) => setSearch(e.target.value)} data-testid="product-search" placeholder="Buscar produto..." className="crm-input pl-10" />
        </form>
        <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} data-testid="product-type-filter" className="crm-input" style={{ maxWidth: "200px" }}>
          <option value="">Todos os tipos</option><option value="product">Produto</option><option value="service">Serviço</option>
        </select>
      </div>

      <div className="crm-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="crm-table">
            <thead><tr><th>Nome</th><th>Tipo</th><th>Preço</th><th>Mensal</th><th>Requisitos</th><th className="text-right">Ações</th></tr></thead>
            <tbody>
              {loading ? (
                [...Array(3)].map((_, i) => <tr key={i}><td colSpan={6}><div className="h-5 rounded animate-pulse" style={{ background: "var(--crm-border)" }} /></td></tr>)
              ) : products.length === 0 ? (
                <tr><td colSpan={6} className="text-center py-12" style={{ color: "var(--crm-text-dim)" }}>Nenhum produto encontrado</td></tr>
              ) : (
                products.map((p) => (
                  <tr key={p.id} data-testid={`product-row-${p.id}`}>
                    <td className="primary">{p.name}</td>
                    <td><span className={p.type === "service" ? "crm-badge crm-badge-blue" : "crm-badge crm-badge-purple"}>{p.type === "service" ? "Serviço" : "Produto"}</span></td>
                    <td style={{ color: "var(--crm-text)", fontWeight: 500 }}>¥{p.price.toLocaleString()}</td>
                    <td>{p.monthly_price ? `¥${p.monthly_price.toLocaleString()}/mês` : "—"}</td>
                    <td>
                      <div className="flex gap-1.5 flex-wrap">
                        {p.requires_document && <span className="crm-badge crm-badge-gray text-[10px]">DOC</span>}
                        {p.requires_selfie && <span className="crm-badge crm-badge-gray text-[10px]">SELFIE</span>}
                        {p.requires_terms && <span className="crm-badge crm-badge-gray text-[10px]">TERMOS</span>}
                        {!p.requires_document && !p.requires_selfie && !p.requires_terms && <span style={{ color: "var(--crm-text-dim)" }}>—</span>}
                      </div>
                    </td>
                    <td className="text-right">
                      <div className="flex items-center justify-end gap-1">
                        <Link to={`/crm/products/${p.id}`} className="p-2 rounded-lg transition-colors" style={{ color: "var(--crm-text-muted)" }}><Pencil className="w-4 h-4" /></Link>
                        <button onClick={() => handleDelete(p.id)} className="p-2 rounded-lg transition-colors hover:text-red-400" style={{ color: "var(--crm-text-dim)" }}><Trash2 className="w-4 h-4" /></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-xs mt-3" style={{ color: "var(--crm-text-dim)" }}>{products.length} produto(s)</p>
    </div>
  );
}
